import { render, staticRenderFns } from "./index.vue?vue&type=template&id=da1cf5f6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=da1cf5f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1cf5f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/data/.jenkins/workspace/yyWebsite/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da1cf5f6')) {
      api.createRecord('da1cf5f6', component.options)
    } else {
      api.reload('da1cf5f6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=da1cf5f6&scoped=true&", function () {
      api.rerender('da1cf5f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/joinUs/index.vue"
export default component.exports